<div id="login-form">
  <div *ngIf="authenticationService.displayChangePasswordAlert" class="alert alert-success"> Your password changed
    successfully. You can now proceed to log in.
  </div>
  <form [formGroup]="registerForm" class="form-horizontal" (ngSubmit)="login()">
    <div [ngClass]="{'has-error': showErrorMessage('email')}" class="p-grid form-group">
      <label class="col-4 col-form-label text-right" for="email">Email</label>
      <div class="col-8 col-form-input">
        <input formControlName="email" id="email" pInputText type="text"/>
        <div *ngIf="submitted && controls.email.errors && controls.email.errors.required" class="show-when-error">Email
          is required
        </div>
        <div *ngIf="submitted && controls.email.errors && controls.email.errors.email" class="show-when-error">Email
          must be a valid email address
        </div>
      </div>
    </div>
    <div [ngClass]="{'has-error': showErrorMessage('password')}" class="p-grid form-group">
      <label class="col-4 col-form-label text-right" for="password">Password</label>
      <div class="col-8 col-form-input">
        <input formControlName="password" id="password" pInputText type="password"/>
        <div *ngIf="submitted && controls.password.errors && controls.password.errors.required" class="show-when-error">
          Password id required
        </div>
      </div>
    </div>
    <div class="p-grid form-group">
      <label class="col-4 col-form-label text-right" for="rememberMe">Keep me logged in</label>
      <div class="col-8 col-form-input">
        <p-checkbox binary="true" formControlName="rememberMe" id="rememberMe"></p-checkbox>
      </div>
    </div>

    <div *ngIf="errorMessage">
      <div class="alert alert-danger">
        <span [innerHTML]="errorMessage"></span>
      </div>
    </div>

    <div class="login-form-actions text-center">
      <div>
        <p-button type="submit" (onClick)="login()" [disabled]="authenticationService.isLoading" id="login" itemid="login"
                  label="Log in" styleClass="btn btn-primary btn-sm text-right"></p-button>
        &nbsp; &nbsp; <a (click)="authenticationService.isLoginMode=false;"><i
        class="fa fa-question-circle alert-dark"></i> Forgot password </a>
      </div>
    </div>

  </form>

  <div class="login-form-footer">
    Information accessed after log-in is confidential and proprietary to McKay Brothers, LLC, Quincy Data, LLC, McKay
    Brothers International SA and
    their respective affiliates (collectively “McKay”) and is subject to the confidentiality agreement (“NDA”) and any
    applicable service agreement
    (e.g., Private Carrier Services Agreement, Master Services Agreement, collectively “Service Agreement”) between the
    individual or entity entering into
    such agreements (“Subscriber”) and McKay.<br>
    By logging in to the McKay website, you agree, as an authorized representative of Subscriber, that information may
    not be accessed, used or
    disseminated except in compliance with the terms of the NDA and applicable Service Agreement.<a
    [target]="'_blank'" [href]="privacyPolicyUrl"> Our Privacy Policy</a> applies
    to your use of this site.
  </div>
</div>
